"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _fetcher = _interopRequireDefault(require("../lib/fetcher"));

function confirmPaymentIntent(_x, _x2) {
  return _confirmPaymentIntent.apply(this, arguments);
}

function _confirmPaymentIntent() {
  _confirmPaymentIntent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(id, body) {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _fetcher["default"])({
              body: {
                id: id,
                body: body
              },
              method: 'POST',
              url: "/api/stripe/confirm/payment-intent"
            });

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _confirmPaymentIntent.apply(this, arguments);
}

function createBillingPortalSession(_x3) {
  return _createBillingPortalSession.apply(this, arguments);
}

function _createBillingPortalSession() {
  _createBillingPortalSession = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(body) {
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _fetcher["default"])({
              body: body,
              method: 'POST',
              url: "/api/stripe/create/billing-portal-session"
            });

          case 2:
            return _context2.abrupt("return", _context2.sent);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _createBillingPortalSession.apply(this, arguments);
}

function createCheckoutSession(_x4) {
  return _createCheckoutSession.apply(this, arguments);
}

function _createCheckoutSession() {
  _createCheckoutSession = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(body) {
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0, _fetcher["default"])({
              body: body,
              method: 'POST',
              url: "/api/stripe/create/checkout-session"
            });

          case 2:
            return _context3.abrupt("return", _context3.sent);

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _createCheckoutSession.apply(this, arguments);
}

function createPaymentIntent(_x5) {
  return _createPaymentIntent.apply(this, arguments);
}

function _createPaymentIntent() {
  _createPaymentIntent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(body) {
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return (0, _fetcher["default"])({
              body: body,
              method: 'POST',
              url: "/api/stripe/create/payment-intent"
            });

          case 2:
            return _context4.abrupt("return", _context4.sent);

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _createPaymentIntent.apply(this, arguments);
}

function retrievePaymentIntent(_x6) {
  return _retrievePaymentIntent.apply(this, arguments);
}

function _retrievePaymentIntent() {
  _retrievePaymentIntent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(id) {
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return (0, _fetcher["default"])({
              body: {
                id: id
              },
              method: 'GET',
              url: "/api/stripe/retrieve/payment-intent"
            });

          case 2:
            return _context5.abrupt("return", _context5.sent);

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _retrievePaymentIntent.apply(this, arguments);
}

function updatePaymentIntent(_x7, _x8) {
  return _updatePaymentIntent.apply(this, arguments);
}

function _updatePaymentIntent() {
  _updatePaymentIntent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(id, body) {
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return (0, _fetcher["default"])({
              body: {
                id: id,
                body: body
              },
              method: 'POST',
              url: "/api/stripe/update/payment-intent"
            });

          case 2:
            return _context6.abrupt("return", _context6.sent);

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _updatePaymentIntent.apply(this, arguments);
}

var _default = {
  confirmPaymentIntent: confirmPaymentIntent,
  createBillingPortalSession: createBillingPortalSession,
  createCheckoutSession: createCheckoutSession,
  createPaymentIntent: createPaymentIntent,
  retrievePaymentIntent: retrievePaymentIntent,
  updatePaymentIntent: updatePaymentIntent
};
exports["default"] = _default;